import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Spin,
  Switch,
  Typography,
  notification,
} from "antd";
import { get, put } from "../../../api/axios";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Title } = Typography;

const EditSellers = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  // STATES
  const [fromLoading, setFromLoading] = useState(false);
  const [inputsValue, setInputsValue] = useState({});
  const [loading, setLoading] = useState(false);

  // SUBMITTERS
  const onFinish = (values) => {
    setLoading(true);
    
    let data = {
      ...values,
    };

    put(`sellers/${id}`, data)
      .then(() => {
        notification.success({ message: "Modified successfully" });
        setLoading(false);
        navigate("/sellers");
      })
      .catch((err) => {
        notification.error({
          message: "Error!",
          description: err.response.data.message,
        });
        setLoading(false);
      });
  };

  useEffect(() => {
    get(`sellers/${id}`).then((res) => {
      setInputsValue(res.data);
      setFromLoading(true);
    });
  }, []);

  return (
    <div>
      <Title level={2} className="text-main mb-2">
        <ArrowLeftOutlined onClick={() => navigate("/sellers")} />
        Edit Seller
      </Title>

      {fromLoading ? (
        <Form
          className="wrapper-content"
          onFinish={onFinish}
          labelCol={{ span: 7 }}
          wrapperCol={{ span: 15 }}
          initialValues={{
            name: inputsValue.name,
            country_code: inputsValue.country_code,
            phone_number: inputsValue.phone_number,
            email: inputsValue.email,
            is_active: inputsValue.is_active,
          }}
          autoComplete="off"
        >
          <div className="row">
            <div className="row">
              {/* Item */}
              <div className="col-lg-6">
                <Form.Item
                  label="Name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "This field is required!",
                    },
                    {
                      min: 10,
                      message: "Name must be at least 10 characters!",
                    }
                  ]}
                >
                  <Input placeholder="Type..." />
                </Form.Item>
              </div>
              {/* Item */}
              <div className="col-lg-6">
                <Form.Item
                  label="Country Code"
                  name="country_code"
                  rules={[
                    {
                      required: true,
                      message: "This field is required!",
                    },
                  ]}
                >
                  <Input placeholder="Type..." />
                </Form.Item>
              </div>
              {/* Item */}
              <div className="col-lg-6">
                <Form.Item
                  label="Phone Number"
                  name="phone_number"
                  rules={[
                    {
                      required: true,
                      message: "This field is required!",
                    },
                    {
                      pattern: /^[0-9]+$/,
                      message: "Phone number must contain digits only!",
                    }
                  ]}
                >
                  <Input placeholder="Type..." />
                </Form.Item>
              </div>
              {/* Item */}
              <div className="col-lg-6">
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "This field is required!",
                    },
                    {
                      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Please enter a valid email!",
                    },
                  ]}
                >
                  <Input placeholder="Type..." />
                </Form.Item>
              </div>
              {/* Item */}
              <div className="col-lg-6">
                <Form.Item label="Active" name="is_active">
                  <Switch defaultChecked={false} />
                </Form.Item>
              </div>
            </div>
          </div>
          <div className="row mt-5 pt-2">
            <div className="col-lg-4 offset-lg-4">
              <Form.Item
                wrapperCol={{
                  offset: 1,
                  span: 16,
                }}
              >
                <Button
                  loading={loading}
                  size="large"
                  block
                  type="primary"
                  htmlType="submit"
                >
                  {loading ? "Updating..." : "Update"}
                </Button>
              </Form.Item>
            </div>
          </div>
        </Form>
      ) : (
        <div className="text-center">
          <Spin size="large" />
        </div>
      )}
    </div>
  );
};

export default EditSellers;
